import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './Maincontent'
const QualityProcedureList = () => {
  return (
     <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>

      <Helmet>
				<title>Quality Procedure List</title>
			</Helmet>
    <Header />
    <MainContent />
    </div>
  )
}
export default QualityProcedureList